import setting from '@/setting.js'

export default {
  namespaced: true,
  state: {
    project: [],
    admin: [],
    user: [],
    per: [],
    asideCollapse: setting.menu.asideCollapse,
    projectCollapse: false,
    userCollapse: false
  },
  actions: {
    projectSet ({ state, dispatch }, project) {
      return new Promise(async resolve => {
        state.project = project
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.project',
          value: state.project,
          user: true
        }, { root: true })
        resolve()
      })
    },
    adminSet ({ state, dispatch }, admin) {
      return new Promise(async resolve => {
        state.admin = admin
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.admin',
          value: state.admin,
          user: true
        }, { root: true })
        resolve()
      })
    },
    userSet ({ state, dispatch }, admin) {
      return new Promise(async resolve => {
        state.admin = admin
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.user',
          value: state.user,
          user: true
        }, { root: true })
        resolve()
      })
    },
    perSet ({ state, dispatch }, per) {
      return new Promise(async resolve => {
        state.per = per
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.per',
          value: state.per,
          user: true
        }, { root: true })
        resolve()
      })
    },
    asideCollapseSet ({ state, dispatch }, collapse) {
      return new Promise(async resolve => {
        state.asideCollapse = collapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    asideCollapseToggle ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.asideCollapse = !state.asideCollapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          value: state.asideCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    asideCollapseLoad ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.asideCollapse = await dispatch('d2admin/db/get', {
          dbName: 'sys',
          path: 'menu.asideCollapse',
          defaultValue: setting.menu.asideCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    projectCollapseSet ({ state, dispatch }, collapse) {
      return new Promise(async resolve => {
        state.projectCollapse = collapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.projectCollapse',
          value: state.projectCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    projectCollapseToggle ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.projectCollapse = !state.projectCollapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.projectCollapse',
          value: state.projectCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    projectCollapseLoad ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.projectCollapse = await dispatch('d2admin/db/get', {
          dbName: 'sys',
          path: 'menu.projectCollapse',
          defaultValue: setting.menu.projectCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    userCollapseSet ({ state, dispatch }, collapse) {
      return new Promise(async resolve => {
        state.userCollapse = collapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.userCollapse',
          value: state.userCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    userCollapseToggle ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.userCollapse = !state.userCollapse
        await dispatch('d2admin/db/set', {
          dbName: 'sys',
          path: 'menu.userCollapse',
          value: state.userCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    },
    userCollapseLoad ({ state, dispatch }) {
      return new Promise(async resolve => {
        state.userCollapse = await dispatch('d2admin/db/get', {
          dbName: 'sys',
          path: 'menu.userCollapse',
          defaultValue: setting.menu.userCollapse,
          user: true
        }, { root: true })
        resolve()
      })
    }
  },
  mutations: {
    projectSet (state, menu) {
      state.project = menu
    },
    adminSet (state, menu) {
      state.admin = menu
    },
    userSet (state, menu) {
      state.user = menu
    },
    perSet (state, menu) {
      // store 赋值
      state.per = menu
    }
  }
}
